import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import ContactForm from "./sections/ContactForm";
import ContactInformation from "./sections/ContactInformation";
import LocationMap from "./sections/LocationMap";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <HeroSection />
      <ContactForm />
      <ContactInformation />
      <LocationMap />
      <CallToAction />
      <Footer />
    </div>;
}